export const EndpointUrl = process.env.REACT_APP_SERVER_URL;
